import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import CampaignInfoBannerContainer from '../CampaignInfoBanner/CampaignInfoBannerContainer.js';
import HeaderContainer from '../Header/HeaderContainer.js';

const Layout = (_param)=> {
    var { children , className , hasNavigation =true , resetHtmlScrolling =false , banner  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "hasNavigation",
        "resetHtmlScrolling",
        "banner"
    ]);
    return React.createElement(React.Fragment, null, resetHtmlScrolling ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
            /* fixes scroll to top issue */
            html {
              overflow: auto;
            }
          `)) : null, /*#__PURE__*/ React.createElement("main", swcHelpers.extends({}, rest, {
        className: classnames('book-appointment-layout', className)
    }), /*#__PURE__*/ React.createElement(HeaderContainer, {
        hasNavigation: hasNavigation
    }), /*#__PURE__*/ React.createElement(CampaignInfoBannerContainer, swcHelpers.extends({}, banner)), /*#__PURE__*/ React.createElement("div", {
        "data-t": "layout-container",
        className: classnames('book-appointment-layout__container', {
            'book-appointment-layout__container--without-navigation': !hasNavigation
        })
    }, children)));
};

export { Layout as default };
//# sourceMappingURL=Layout.js.map
